export const reportCardConstants = {
    // Add and editing report card
    SAVING_REPORT_CARD_REQUEST: 'SAVING_REPORT_CARD_REQUEST',
    SAVING_REPORT_CARD_SUCCESS: 'SAVING_REPORT_CARD_SUCCESS',
    SAVING_REPORT_CARD_FAILURE: 'SAVING_REPORT_CARD_FAILURE',

    // Loading report cards
    LOAD_REPORT_CARDS_REQUEST: 'LOAD_REPORT_CARDS_REQUEST',
    LOAD_REPORT_CARDS_SUCCESS: 'LOAD_REPORT_CARDS_SUCCESS',
    LOAD_REPORT_CARDS_FAILURE: 'LOAD_REPORT_CARDS_FAILURE',

    // Delete report card
    DELETE_REPORT_CARD_REQUEST: 'DELETE_REPORT_CARD_REQUEST',
    DELETE_REPORT_CARD_SUCCESS: 'DELETE_REPORT_CARD_SUCCESS',
    DELETE_REPORT_CARD_FAILURE: 'DELETE_REPORT_CARD_FAILURE',
}


// WEBPACK FOOTER //
// ./src/redux/constants/reportCard.constants.js